interface FilterGroupProps {
  title: string;
  options: string[];
  selected: string[];
  onToggle: (value: string) => void;
}

function FilterGroup({ title, options, selected, onToggle }: FilterGroupProps) {
  return (
    <div className="border-t border-background-200 py-4 first:border-t-0 first:pt-0">
      <h3 className="mb-2.5 font-heading text-xs font-bold uppercase tracking-wider text-foreground-500">
        {title}
      </h3>
      <div className="flex flex-wrap gap-1.5">
        {options.map((option) => {
          const active = selected.includes(option);
          return (
            <button
              key={option}
              type="button"
              aria-pressed={active}
              onClick={() => onToggle(option)}
              className={`cursor-pointer whitespace-nowrap rounded-md px-2.5 py-1 text-xs transition-colors ${
                active
                  ? 'bg-primary-900 font-medium text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
}

interface FilterPanelProps {
  genres: string[];
  regions: string[];
  years: string[];
  selectedGenres: string[];
  selectedRegions: string[];
  selectedYears: string[];
  onToggleGenre: (value: string) => void;
  onToggleRegion: (value: string) => void;
  onToggleYear: (value: string) => void;
  onReset: () => void;
  activeCount: number;
}

export default function FilterPanel({
  genres,
  regions,
  years,
  selectedGenres,
  selectedRegions,
  selectedYears,
  onToggleGenre,
  onToggleRegion,
  onToggleYear,
  onReset,
  activeCount,
}: FilterPanelProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4">
      <div className="flex items-center justify-between pb-4">
        <div className="flex items-center gap-1.5">
          <i className="ri-filter-3-line text-sm text-primary-700" />
          <h2 className="font-heading text-sm font-bold text-foreground-950">筛选条件</h2>
          {activeCount > 0 && (
            <span className="rounded-full bg-accent-500 px-1.5 text-[10px] font-bold leading-4 text-accent-950">
              {activeCount}
            </span>
          )}
        </div>
        <button
          type="button"
          onClick={onReset}
          className="cursor-pointer text-[11px] text-foreground-500 transition-colors hover:text-accent-700"
        >
          重置
        </button>
      </div>

      <FilterGroup title="类型" options={genres} selected={selectedGenres} onToggle={onToggleGenre} />
      <FilterGroup title="地区" options={regions} selected={selectedRegions} onToggle={onToggleRegion} />
      <FilterGroup title="年份" options={years} selected={selectedYears} onToggle={onToggleYear} />
    </div>
  );
}